/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's opyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { JWKS } from '../housien-models/JWKS';
import type { OAuth2ServerMetadata } from '../housien-models/OAuth2ServerMetadata';

import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';
import { OpenAPIConfig } from '../core/OpenAPI';
import { getRequiredEnvVar } from '@shared/utils/validate-env';
import type {
    UserInfoResponse,
    LogoutResponse,
    LogoutRequestBody,
} from './OpenIdService.types';

/**
 * Builds the OpenAPI client configuration for the authority (OIDC) server.
 *
 * @returns {OpenAPIConfig} Configuration object with base URL and request settings.
 */
function getOpenAPIConfig(): OpenAPIConfig {
    return {
        BASE: getRequiredEnvVar('REACT_APP_AUTHORITY_URL'),
        VERSION: '1.0.0',
        WITH_CREDENTIALS: false,
        CREDENTIALS: 'include',
    };
}

/**
 * OpenIdService class.
 */
export class OpenIdService {

    /**
     * OpenID Configuration
     * @returns OAuth2ServerMetadata Server metadata
     * @throws ApiError
     */
    public static getOpenIdConfiguration(): CancelablePromise<OAuth2ServerMetadata> {
        return __request(getOpenAPIConfig(), {
            method: 'GET',
            url: '/.well-known/openid-configuration',
        });
    }

    /**
     * Retrieve JSON Web Key Set (JWKS)
     * Retrieve JWKS containing public keys used for JWT verification. Clients must include their `client_id` and `client_secret` in the Authorization header using HTTP Basic Authentication to access this endpoint.
 * 
     * @returns JWKS Successful response containing the JWKS.
     * @throws ApiError
     */
    public static getOpenIdjwks(): CancelablePromise<JWKS> {
        return __request(getOpenAPIConfig(), {
            method: 'GET',
            url: '/.well-known/jwks.json',
        });
    }

    /**
     * Get user information
     * Returns claims about the authenticated user.
     * @returns any User information response
     * @throws ApiError
     */
    public static getUserInfo(): CancelablePromise<UserInfoResponse> {
        return __request(getOpenAPIConfig(), {
            method: 'GET',
            url: '/userinfo',
        });
    }

    /**
     * Logout User
     * Logs out the current user by invalidating the session.
     * @param requestBody 
     * @returns any Successfully logged out
     * @throws ApiError
     */
    public static logoutUser(
requestBody: LogoutRequestBody,
): CancelablePromise<LogoutResponse> {
        return __request(getOpenAPIConfig(), {
            method: 'POST',
            url: '/logout',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
